import { routes } from '../app/appMainRoutes';

const mappingRoute = `${routes.enrichment}/mappings`;

export const enrichmentRoutes = {
  mappingCompanies: `${mappingRoute}/companies`,
  mappingContacts: `${mappingRoute}/contacts`,
};
